export default {
  data() {
    return {
      screenWidth: document.body.clientWidth
    };
  },
  watch: {
    screenWidth(val) {
      this.screenChange(val);
    }
  },
  created() {
    this.screenChange(this.screenWidth);
  },
  mounted() {
    /*  监听窗口变化  */
    const that = this;
    window.onresize = () =>
      (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
  },
  methods: {
    screenChange(val) {
      if (val < 768) {
        this.$store.commit("SetScreenWidth", true);
      } else {
        this.$store.commit("SetScreenWidth", false);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/common.js